import styled, { css } from 'styled-components';
import { SplitButton } from 'primereact/splitbutton';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const BottomText = styled.p`
    color: #000000;
    font-size: 20px;
    margin-right: 15px;
`;
export const HeaderData = styled.div`
    font-family: AvenirNextWorld Regular;
    color: #3c3c3c;
    padding: 8px 0px 8px 0px;
`;

export const HeaderLeftBordered = styled.div`
    font-family: AvenirNextWorld Regular;
    color: #3c3c3c;
    border-left: ${(props) => props.borderLeft};
    width: 100%;
    height: 100%;
    padding: ${(props) => (props.padding ? props.padding : '2px 8px')};
    margin-left: ${(props) => (props.showScrollBar ? '-5px' : '')};
    ${media.smalDevice`
        margin-left: 0;
    `}
    ${media.mediumDevice`
        margin-left: 0;   
    `}
`;
export const UNiDContainer = styled.div`
    color: #1010eb;
    font-size: 12px;
    font-family: AvenirNextWorld Regular;
    height: ${(props) => (props.height ? props.height : 'auto')};
    display: flex;
`;

export const UNiDText = styled.span`
    color: #3c3c3c;
    font-family: AvenirNextWorld Regular;
    margin-right: 2px;
`;

export const BodyContainer = styled.div`
    margin: 0;
    padding: 0 0 0 10px;
    border-left: 3px solid ${(props) => (props.color ? props.color : 'black')};
    height: ${(props) => (props.height ? props.height : '100%')};
    display: flex;
    align-items: center;
    .p-menu-overlay {
        display: none !important;
    }
    .p-menu {
        display: none !important;
    }
`;
export const DemiText = styled.p`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => color};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    font-weight: ${(props) => props.fontWeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
    ${media.mobileDevice`
    font-size: ${({ mbFontSize }) => mbFontSize};
    margin-bottom:${({ marginBottom }) => marginBottom};
    line-height: 20px;
    color: ${(props) => (props.color ? props.color : '#202124')};
`}
`;
export const StatusText = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 12px;
    //width:77px;
    height: 22px;
    line-height: ${({ lineHeight }) => lineHeight};
`;
export const StatusFilterText = styled.div`
    @media only screen and (min-width: 768px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
    @media only screen and (min-width: 1024px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
`;
export const StatusFilterDiv = styled.div`
    @media only screen and (min-width: 768px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
    @media only screen and (min-width: 1024px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
`;

export const SmallHeaderText = styled.p`
    font-family: AvenirNextWorld Regular;
    font-size: 10px;
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const BoldTruncatedItem = styled.p`
    font-family: AvenirNextWorld Demi;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    //width:125px;
    height: 21px;
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const RegularText = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    color: ${(props) => (props.color ? props.color : '#070707')};
`;
export const AccountNameNumberText = styled(RegularText)`
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection};
    ${media.mediumDevice`
        flex-direction: ${({ mdFlexDirection }) => mdFlexDirection};
        margin: ${({ mdMargin }) => mdMargin};
    `}
`;
export const RegularTruncateText = styled.div`
    font-family: AvenirNextWorld Regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    color: ${(props) => (props.color ? props.color : '#070707')};
    height: ${(props) => (props.height ? props.height : 'auto')};
    line-height: ${(props) => (props.lineHeight ? props.lineHeight : 'auto')};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const ProcedureTruncateText = styled.div`
    font-family: AvenirNextWorld Regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    color: ${(props) => (props.color ? props.color : '#070707')};
    height: ${(props) => (props.text ? '22px' : '16px')};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const CaseRefText = styled.p`
    font-weight: bold;
    color: #1010eb;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;

export const SurgeryDateText = styled.div`
    padding-left: 5px;
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;

export const PaginatorContainer = styled.div`
    & > div {
        background-color: transparent;
    }
    & > div > .p-paginator-current {
        flex: 1;
        justify-content: start;
    }
`;

export const DataTableContainer = styled.div`
    .p-datatable-scrollable-header-box {
        margin-right: 0 !important;
    }
    .p-paginator-pages {
        padding-top: 5px;
        font-family: AvenirNextWorld Demi;
        display: flex;
        line-height: 22px;

        & > p {
            line-height: 22px;
        }
    }
    .p-datatable .p-datatable-tbody > tr > td {
        padding: ${({ padding }) => (padding ? padding : '2px')};
        font-size: 13px;
        height: ${({ height }) => (height ? height : '87px')};
        border: ${({ border }) => (border ? border : 'none')};
    }

    .p-datatable .p-datatable-scrollable-header {
        border-top-left-radius: 10px !important;
        border-top-right-radius: 10px !important;
    }

    .p-datatable .p-datatable-scrollable-body {
        max-height: calc(100vh - 22rem);
        border-bottom-left-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
        ${scrollBarStyle}

        /* &::-webkit-scrollbar {
            display: ${({ showScrollBar }) =>
            showScrollBar ? 'block' : 'none'};
            width: 5px;
            border-radius: 25px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 0px;
            border-radius: 25px;
        }
        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 25px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #555;
            border-radius: 25px;
        } */
        ${media.smalDevice`
        &::-webkit-scrollbar {
            display:  none;  
        }
        `}
        ${media.mediumDevice`
        &::-webkit-scrollbar {
            display:  none;    
        }
        `}
    }

    .p-datatable .p-datatable-thead > tr > th {
        padding: 2px 2px 2px 4px;
    }

    .p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
        display: none;
    }

    .p-datatable {
        font-family: AvenirNextWorld Demi;
        color: #3c3c3c;
        border-radius: 6px;
    }

    .p-datatable-scrollable-wrapper {
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000029;
        border: 1px solid #dcdcdc;
        border-radius: 6px;
    }

    .p-datatable-thead {
        font-size: 13px;
        background: #ffffff;
        box-shadow: 0px 1px 2px #00000029;
        border-bottom: ${({ headerBorderBottom }) =>
            headerBorderBottom ? headerBorderBottom : '2px solid #dcdcdc'};
        border-radius: 6px 6px 0px 0px;
    }

    .p-datatable .p-datatable-thead > tr > th {
        background-color: #ffffff;
    }

    .p-datatable .p-sortable-column.p-highlight {
        background: white;
        color: #3c3c3c;
        border: none;

        &:hover,
        :active {
            background: white;
            color: #3c3c3c;
            border: none;
        }
    }

    .pi:before {
        visibility: hidden;
    }

    .p-dropdown-trigger-icon.p-clickable.pi.pi-chevron-down:before {
        visibility: visible;
        font-size: 10px;
    }

    .p-dropdown-trigger-icon.p-clickable.pi.pi-chevron-down {
        padding-bottom: 5px;
    }

    .p-sortable-column .p-sortable-column-icon.pi-sort-amount-up-alt {
        content: url(${(props) => props.sortAscIcon});
        width: 12px;
        height: 12px;
    }

    .p-sortable-column .p-sortable-column-icon.pi-sort-amount-down {
        content: url(${(props) => props.sortDescIcon});
        width: 12px;
        height: 12px;
    }
    .p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd {
        background-color: ${({ backgroundColorOdd }) =>
            backgroundColorOdd ? backgroundColorOdd : '#f5f5f599'};
    }
    .p-datatable.p-datatable-striped .p-datatable-tbody > tr {
        background-color: ${({ backgroundColorEven }) =>
            backgroundColorEven ? backgroundColorEven : '#ffffffcc'};
    }

    p {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
    }

    .p-datatable .p-paginator-bottom {
        font-family: AvenirNextWorld Demi;
        line-height: 25px;
        background-color: ${({ backgroundColorPagination }) =>
            backgroundColorPagination ? backgroundColorPagination : '#f5f5f5'};
        box-shadow: 0;
        border: none;
        padding: 18px 0 0 0;
    }
    .p-dropdown {
        width: 95%;
    }
    .p-dropdown-label.p-inputtext {
        font-family: AvenirNextWorld Regular;
        font-size: 12px;
        padding-top: 2px;
        padding-bottom: 2px;
        color: #140f4b;
    }

    ${({ isListView }) =>
        isListView &&
        css`
            .p-datatable .p-sortable-column .p-column-title,
            .p-datatable .p-sortable-disabled .p-column-title {
                width: 60%;
                display: inline-block;
                line-height: 18px;
                height: auto;
                padding: 2px 0 0 0;
                vertical-align: top;
                margin: 0;
                ${media.smalDevice`{
                    display: ${({ displayType }) =>
                        displayType ? displayType : 'inline-block'};
                }`}
                ${media.mediumDevice`{
                    display: ${({ displayType }) =>
                        displayType ? displayType : 'inline-block'};
                }`}
            }

            .p-datatable .p-sortable-column .p-sortable-column-icon {
                padding: 4px 0 0 0;
                display: inline-block;
                vertical-align: top;
            }
            .p-sortable-column .p-sortable-column-icon {
                margin: 2px;
                vertical-align: top;
                margin-left: ${(props) => props.sortMargin};
            }
            .p-datatable .p-sortable-column .p-sortable-column-icon.pi-fw {
                width: 1em !important;
            }
        `};
    .p-datatable .data-subtable {
        padding: 0;
    }

    ${({ showSubTable }) =>
        showSubTable &&
        css`
            .data-subtable .p-datatable .p-datatable-tbody {
                border-radius: 6px;
            }
        `};

    .data-subtable .p-datatable-thead {
        display: none;
    }

    .data-subtable .p-datatable table {
        width: ${({ subTableWidth }) =>
            subTableWidth ? subTableWidth : '95%'};
        margin: 0 auto;
        border: 1px solid #dcdcdc;
    }

    /* @media screen and (max-width: 850px) {
        .p-datatable.p-datatable-responsive .p-datatable-thead > tr > th {
            display: none !important;
        }

        .p-datatable.p-datatable-responsive .p-datatable-tfoot > tr > td {
            display: none !important;
        }

        .p-datatable.p-datatable-responsive .p-datatable-tbody > tr > td {
            text-align: left;
            display: block;
            border: 0 none !important;
            width: 100% !important;
            float: left;
            clear: left;
        }

        .p-datatable.p-datatable-responsive
            .p-datatable-tbody
            > tr
            > td
            .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4em 1em -0.4em -0.4rem;
            font-weight: bold;
        }
    } */
`;

export const StyledCasesCountFooter = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    color: #3c3c3c;
`;
export const SplitButtonContainer = styled(SplitButton)`
    height: auto;
    width: 93%;
    margin-left: 0rem;
    outline: none;
    border: 1px solid #70707033 !important;
    border-radius: 4px;
    .p-button {
        color: #140f4b;
        background: #ffffff;
        padding: 2px 10px;
        font-size: 12px;
        text-align: left;
        outline: none;
        border: 1px solid #ffffff !important;
    }
    .p-splitbutton {
        display: inline-flex;
        position: relative;
        width: 90%;
        border-radius: 4px;
    }
    .p-button:not(a):not(.p-disabled):active {
        background: #70707033 !important;
        color: #140f4b !important;
        border-color: #70707033 !important;
        outline: none;
        border-color: #ffffff !important;
    }

    .p-button:not(a):not(.p-disabled):hover {
        background: #70707033 !important;
        color: #140f4b !important;
        border-color: #70707033 !important;
        outline: none;
        border-color: #ffffff !important;
    }
    .p-button:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #f9f9f90d;
    }
    .p-button-label {
        font-family: AvenirNextWorld Regular;
        word-wrap: break-word;
    }

    .pi-chevron-down:before {
        visibility: visible;
        font-size: 12px;
        color: #3c3c3c;
    }
    .p-button-icon-only .p-button-label {
        visibility: visible;
        width: 0px;
        height: 0px;
    }
    .p-button.p-button-icon-only {
        border-left-color: #ffffff !important;
        width: 28px;
        height: auto;
        padding: 6px;
        display: ${({ display }) => (display ? display : '')};
    }
`;
